(() => {
  const mq = window.matchMedia("(max-width: 749px)");
  const HIDE_AFTER = 80; // px before hiding on scroll down

  const getScrollTop = () =>
    (document.scrollingElement && document.scrollingElement.scrollTop) ||
    document.documentElement.scrollTop ||
    window.pageYOffset ||
    0;

  function init() {
    if (!mq.matches) return;

    const ann = document.querySelector(".announcement-bar-section");
    const header = document.querySelector(".section-header.shopify-section-header-sticky");

    // Set CSS vars for heights (and keep them updated)
    const setHeights = () => {
      if (!mq.matches) return;

      const annH = ann ? Math.round(ann.getBoundingClientRect().height) : 0;
      const headerH = header ? Math.round(header.getBoundingClientRect().height) : 0;

      document.documentElement.style.setProperty("--kh-ann-h", `${annH}px`);
      document.documentElement.style.setProperty("--kh-header-h", `${headerH}px`);
    };

    setHeights();

    // Auto-update heights if anything changes (fonts / editor / dynamic changes)
    if ("ResizeObserver" in window) {
      const ro = new ResizeObserver(() => setHeights());
      if (ann) ro.observe(ann);
      if (header) ro.observe(header);
    } else {
      window.addEventListener("resize", setHeights);
      window.addEventListener("orientationchange", setHeights);
    }

    let lastY = getScrollTop();
    let ticking = false;

    const update = () => {
      if (!mq.matches) return;

      const y = getScrollTop();
      const goingDown = y > lastY;

      // Always show at top
      if (y <= 10) {
        document.body.classList.remove("kh-ann-hidden");
      } else {
        // hide on scroll down after threshold, show on scroll up
        if (goingDown && y > HIDE_AFTER) {
          document.body.classList.add("kh-ann-hidden");
        } else if (!goingDown) {
          document.body.classList.remove("kh-ann-hidden");
        }
      }

      lastY = y;
    };

    const onScroll = () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          update();
          ticking = false;
        });
        ticking = true;
      }
    };

    // IMPORTANT: theme editor sometimes needs document scroll capture
    window.addEventListener("scroll", onScroll, { passive: true });
    document.addEventListener("scroll", onScroll, { passive: true, capture: true });

    // Run once
    update();

    // If breakpoint changes
    mq.addEventListener?.("change", () => {
      document.body.classList.remove("kh-ann-hidden");
      setHeights();
      lastY = getScrollTop();
      update();
    });
  }

  // Make sure body exists
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();